module.exports = __webpack_public_path__ + "img/journal.cee0b24e.png";